export default class browserBack {
    constructor() {
        this.dom = {
        };

        this.init();
    }

    init() {
        this.browserBack();
    }

    //Try to prevent users using the browser back button
    browserBack() {
        history.pushState(null, null, location.href);
        history.back();
        history.forward();
        window.onpopstate = function () {
            history.go(1);
            cLog('Using this can cause data loss, please use the "Back" button on the page instead.');
        };
    }
}